import { IApiCustomer, ICustomer } from '../interfaces/ICustomer'

class Transformer {
  static transform(data: IApiCustomer): ICustomer {
    const defaultInvoiceInformation = {
      name: null,
      street: null,
      city: null,
      postal: null,
      vatNumber: null,
      birthday: '',
      zipcode: null,
    }
    const customer: ICustomer = {
      id: data.id,
      uuid: data.uuid,
      firstName: data.first_name,
      lastName: data.last_name || null,
      fullName: data.full_name,
      email: data.email,
      image: data.image,
      gender: data.gender,
      address: data.address,
      city: data.city,
      zipcode: data.zipcode,
      invoiceInformation:
        data.invoice_name ||
        data.invoice_address ||
        data.invoice_location ||
        data.invoice_postal ||
        data.invoice_vat_number
          ? {
              name: data.invoice_name ?? null,
              street: data.invoice_address ?? null,
              city: data.invoice_location ?? null,
              postal: data.invoice_postal ?? null,
              vatNumber: data.invoice_vat_number ?? null,
              birthday: data.customer_birth_day,
            }
          : defaultInvoiceInformation,
    }
    return customer
  }

  static reverseTransform(customer: ICustomer): IApiCustomer {
    return {
      id: customer.id,
      uuid: customer.uuid,
      first_name: customer.firstName,
      full_name: customer.fullName,
      email: customer.email,
      image: customer.image,
      gender: customer.gender,
      address: customer.address,
      invoice_name: customer.invoiceInformation?.name,
      invoice_address: customer.invoiceInformation?.street,
      invoice_postal: customer.invoiceInformation?.postal,
      invoice_location: customer.invoiceInformation?.city,
      invoice_vat_number: customer.invoiceInformation?.vatNumber,
      invoice_health_insurance_number:
        customer.invoiceInformation?.healthInsuranceNumber,
      customer_birth_day: customer.invoiceInformation.birthday,
      zipcode: customer.invoiceInformation.zipcode,
      city: customer.invoiceInformation.city,
    }
  }
}

export default Transformer
